// @flow
import React, { ComponentType } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import type { Dispatch } from 'react-redux';
import Typography from '@material-ui/core/Typography';

import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import TextField from '@material-ui/core/TextField';
import { withStyles } from '@material-ui/core/styles';

import withStdDialog, { isDialogCloseAction } from '../StdDialog';

import { styles } from './styles';
import type { ConfirmationDialogProps, ACTION_EVENT_TYPES } from './types';

export { DIALOG_TYPE, mkConfirmationDialogProps } from './types';

const CONTENT_VIEWS = {};

export const registerContentView = (key: string, component: ComponentType<any>) => {
  CONTENT_VIEWS[key] = component;
};

type Props = ConfirmationDialogProps & {
  onClose: (ACTION_EVENT_TYPES) => void,
  dispatch: Dispatch,

  closeDialog: () => void,
  onRef: (any) => void,

  classes: Object,
}

type State = {
  confirmButtonDisabled: boolean,
}

class ConfirmationDialog extends React.PureComponent<Props, State> {

  constructor(props) {
    super(props);

    this.state = {
      confirmButtonDisabled: Boolean(props.textEntryConfirmationText),
    };
  }

  componentDidMount() {
    this.props.onRef(this);
  }

  handleTextEntryConfirmation = (event) => {
    const { textEntryConfirmationText } = this.props;
    this.setState({ confirmButtonDisabled: event.target.value !== textEntryConfirmationText });
  };

  handleClose = (_event: Event, dEvent: ACTION_EVENT_TYPES) => {
    const {
      closeDialog,
      confirmAction,
      contentViewId,
      denyAction,
      dialogCloseAliasAction,
      dispatch,
      onClose,
      unregisterContentViewOnClose,
    } = this.props;

    if (onClose) {
      onClose(dEvent);
    }
    closeDialog();

    if ((dEvent === 'CONFIRM' || (dialogCloseAliasAction === 'CONFIRM' && isDialogCloseAction(dEvent))) && confirmAction) {
      if (typeof confirmAction === 'function') {
        confirmAction(dEvent);
      } else {
        dispatch(confirmAction);
      }
    }
    if ((dEvent === 'DENY' || (dialogCloseAliasAction === 'DENY' && isDialogCloseAction(dEvent))) && denyAction) {
      if (typeof denyAction === 'function') {
        denyAction(dEvent);
      } else {
        dispatch(denyAction);
      }
    }
    if (contentViewId && unregisterContentViewOnClose) {
      delete CONTENT_VIEWS[contentViewId];
    }
  };

  render() {
    const { classes, content, contentViewId, confirmLabel, denyLabel, textEntryConfirmationText } = this.props;
    const { confirmButtonDisabled } = this.state;
    const isString = typeof this.props.content === 'string';
    return (
      <>
        <DialogContent>
          {content &&
            <DialogContentText id="confirmation-dialog-description">
              {isString &&
              <Typography variant="subtitle1">
                {content}
              </Typography>
              }
              {!isString &&
              <>
                {content}
              </>
              }
            </DialogContentText>
          }

          {contentViewId && CONTENT_VIEWS[contentViewId]}
          {textEntryConfirmationText &&
            <TextField
              autoFocus
              className={classes.confirmationTextField}
              id="text-confirmation"
              label={`Type ${textEntryConfirmationText} to confirm`}
              onChange={this.handleTextEntryConfirmation}
            />
          }
        </DialogContent>
        <DialogActions>
          <Button id={`confirm-${denyLabel}`} onClick={(event) => this.handleClose(event, 'DENY')} color="primary">
            {denyLabel}
          </Button>
          <Button id={`confirm-${confirmLabel}`} disabled={confirmButtonDisabled} onClick={(event) => this.handleClose(event, 'CONFIRM')} color="primary">
            {confirmLabel}
          </Button>
        </DialogActions>
      </>
    );
  }
}

export default compose(
  withStdDialog(),
  withStyles(styles, { name: 'ConfirmationDialog' }),
  connect(null, (dispatch) => ({ dispatch })),
)(ConfirmationDialog);
